module.exports = __webpack_public_path__ + "img/media-6.90c7912b.jpg";